import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=bc6acf8a&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"
import style0 from "./Home.vue?vue&type=style&index=0&id=bc6acf8a&prod&scoped=true&lang=css"
import style1 from "./Home.vue?vue&type=style&index=1&id=bc6acf8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc6acf8a",
  null
  
)

export default component.exports